//#region IMPORTS
import { ReactNode } from "react";
import classNames from "../../helpers/classNames";
//#endregion

// Sticky strip for a page's tabs (Orders, Promos). It sticks right under the
// dashboard header bar (h-24 = 6rem) and has a FIXED height (h-12 = 3rem), so
// the PageHeader and MainFilterBar below it can be pushed down by exactly that
// amount: both read the `--tabs-offset` CSS variable in their sticky `top`,
// and the page sets that variable on a common ancestor of the tabs, the header
// and the filter bar with STICKY_TABS_OFFSET_CLASS. Pages without tabs never
// set it, so it falls back to 0 there and nothing moves.
//
// Keep the h-12 below and the 3rem in STICKY_TABS_OFFSET_CLASS in sync.
export const STICKY_TABS_OFFSET_CLASS = "[--tabs-offset:3rem]";

//#region INTERFACE
interface Props {
  children: ReactNode;
  classNamesExtensions?: string;
}
//#endregion

export default function MainStickyTabsBar({
  children,
  classNamesExtensions,
}: Props) {
  //#region RENDER
  return (
    <div
      className={classNames(
        // z-[47]: just above PageHeader (z-[46]) so a row scrolling past can
        // never peek through between the two.
        "sticky top-24 z-[47] h-12 bg-white flex flex-col justify-end",
        classNamesExtensions
      )}
    >
      {children}
    </div>
  );
  //#endregion
}
